import { Component } from '@angular/core';

@Component({
    selector: 'lib-quest-atlas-angular-components',
    imports: [],
    template: `
    <p>
      quest-atlas-angular-components works!
    </p>
  `,
    styles: ``
})
export class QuestAtlasAngularComponentsComponent {

}
